import type { Order, OrderItem, OrderView, WarehouseOrderItem } from '@lombok/shared';

/**
 * Warehouse receives orders without prices, totals, exchange rate or seller (the API removes
 * them). Check with this before reading any money field of an order.
 */
export function isPriced(order: OrderView): order is Order {
  return 'totalMinorUsd' in order;
}

/** The lines of an order with their prices (every role but warehouse gets them). */
export function pricedItems(items: ReadonlyArray<OrderItem | WarehouseOrderItem>): OrderItem[] {
  return items.filter((item): item is OrderItem => 'unitPriceMinorUsd' in item);
}
